module.exports = __webpack_public_path__ + "static/es-de3e2e860df7b684c28e368518ce2b1f.jpg";